<template>

<div class="stats-wrapper">
<div class="background-pattern">

  </div>
  <div class="left">
    <div class="inner-wrapper">
      <div class="left-inner left-inner-1">
        <span class="stat-val">{{qbRating}}</span>
        <span class="stat-cat">QB RATING</span>
      </div>
      <div class="left-inner left-inner-2">
        <span class="stat-val">{{completions}}</span>
        <span class="stat-cat">COMPLETIONS</span>
      </div>
    </div>
  </div>


  <div class="right">
    <div class="inner-wrapper">
      <div class="left-inner left-inner-1">
        <span class="stat-val">{{touchdowns}}</span>
        <span class="stat-cat">TOUCHDOWNS</span>
      </div>
      <div class="left-inner left-inner-2">
        <span class="stat-val">{{yards}}</span>
        <span class="stat-cat">YARDS</span>
      </div>
    </div>
</div>
 
</div>
</template>

<script>

export default {
  name: 'StatsFlex',
    props: {
    qbRating: '',
    completions: '',
    touchdowns:'',
    yards:''
  },
  data: function () {
    return {

  }
}

}

</script>

<style>

.stats-wrapper {
  display:flex;
  justify-content: space-between;
  height:200px;
  width:100%;
  border-top: 7px solid black;
  border-bottom: 7px solid black;
  font-family: 'Teko', sans-serif;
  font-weight: 700;
  font-size:60px;
}
.stats-wrapper:after {
    content: '';
    position: absolute;
    width: 7px;
    height: 200px;
    background: black;
    left: 50%;
    transform: skewX(-12deg);
}

.left {
  background:;
  width: 50%;
}


.center:before {
    content: '';
    background: #000000;
    height: 7px;
    width: 43px;
    display: block;
    position: absolute;
    left: -17px;
    transform: skewX(-12deg);
    top: 97px;
}

.right {
    background:;
  width: 50%; 
}


/*.left > .inner-wrapper {

background: rgb(150,150,150); 
background: -moz-linear-gradient(left, rgba(150,150,150,1) 1%, rgba(240,240,240,1) 34%, rgba(255,255,255,1) 82%); 
background: -webkit-linear-gradient(left, rgba(150,150,150,1) 1%,rgba(240,240,240,1) 34%,rgba(255,255,255,1) 82%); 
background: linear-gradient(to right, rgba(150,150,150,1) 1%,rgba(240,240,240,1) 34%,rgba(255,255,255,1) 82%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#969696', endColorstr='#ffffff',GradientType=1 );
}

.right > .inner-wrapper {
background: rgb(255,255,255); 
background: -moz-linear-gradient(left, rgba(255,255,255,1) 18%, rgba(240,240,240,1) 66%, rgba(150,150,150,1) 99%); 
background: -webkit-linear-gradient(left, rgba(255,255,255,1) 18%,rgba(240,240,240,1) 66%,rgba(150,150,150,1) 99%); 
background: linear-gradient(to right, rgba(255,255,255,1) 18%,rgba(240,240,240,1) 66%,rgba(150,150,150,1) 99%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#969696',GradientType=1 ); 
}

*/


.inner-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100%;
}


.left-inner {
    height: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}




span.stat-val {
    line-height: 55px;
    width: 100%;
    font-size: 70px;
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

span.stat-cat {
    font-size: 30px;
    line-height: 30px;
    height: 30%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}


.left-inner-2 {
    border-top: 7px solid black;
}


@media (max-width:420px) {

  .background-pattern {
    background-image: url(https://t3.ftcdn.net/jpg/01/04/46/88/240_F_104468854_qSQs8E4nruOVssnDMYXUvuEhgvMa9OTp.jpg);
    height: 200px;
    width: 100%;
    position: absolute;
    opacity: .02;
    background-size: 20%;
}

span.stat-val {
    line-height: 40px;
    font-size: 50px;
}

span.stat-cat {
    font-size: 20px;
    line-height: 20px;
}

}


</style>


// WEBPACK FOOTER //
// src/components/StatsFlex.vue